module.exports = __webpack_public_path__ + "img/3.698e8726.png";